import _extends from "@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
// Utilities
import { v4 as uuid } from 'uuid';
export default class LogCenter {
  constructor(strategies, storage) {
    this.strategies = void 0;
    this.storage = void 0;
    this.strategies = strategies;
    this.storage = storage;
  }
  log(payload) {
    var _this = this;
    return _asyncToGenerator(function* () {
      yield _this.storage.store(_extends({
        uid: uuid()
      }, payload));
      yield Promise.all(_this.strategies.map(strategy => strategy.notify()));
    })();
  }
}
//# sourceMappingURL=LogCenter.js.map